import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { AtributosProjetoService } from 'src/app/shared/services/atributos-projeto.service';

@Injectable({
  providedIn: 'root'
})
export class ListAtributosProjetoResolver implements Resolve<boolean> {

  constructor(private service: AtributosProjetoService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}
